import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addChecklistItem } from "./api";
import type { AddChecklistItemRequest, ChecklistItem } from "./api";

// POST одного пункта. На успех инвалидируем список пары (org, repo) — новый
// пункт появится в таблице без ручного refetch'а. Инвалидация по
// смысловому префиксу (repo_full_name, тот же что у useChecklist)
// матчит запись любого org-скоупа (см. `src/query/scope.ts`).
export function useAddChecklistItem(): ReturnType<
  typeof useMutation<ChecklistItem, Error, AddChecklistItemRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<ChecklistItem, Error, AddChecklistItemRequest>({
    mutationFn: (body) => addChecklistItem(body),
    onSuccess: (_item, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["reviewerChecklist", variables.repo_full_name.trim()],
      });
    },
  });
}
